import app from '../../app';

app
  .directive('estimateRow', () => ({
    restrict: 'EA',
    template: require('./estimate-row.html'),
    link() {},
  }));
